<template>
  <div>
    <div class="case-pice">
      <span class="case-pice-first">报名设置</span>
      <span class="case-pice-and">/</span>
      <span class="case-pice-second">首页</span>
    </div>
    <div class="common-title">
      报名费用设置
      <el-button
        size="small"
        style="width: 88px; float: right"
        type="primary"
        @click="saveSetUp()"
        plain
        >保存</el-button
      >
    </div>
    <div class="type-wrapper">
      <span
        class="type-title"
        @click="chooseType(1)"
        :style="setUpType == 1 ? 'color:blue;' : ''"
        >两类人员报名费用</span
      >
      <span
        class="type-title"
        @click="chooseType(2)"
        :style="setUpType == 2 ? 'color:blue;' : ''"
        >动态监控报名费用</span
      >
      <span
        class="type-title"
        @click="chooseType(3)"
        :style="setUpType == 3 ? 'color:blue;' : ''"
        >其他类别报名费用</span
      >
    </div>

    <div v-if="setUpType == 1">
      <div>
        继续教育报名费用：
        <el-input
          v-model="searchData.continueFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入继续教育报名费用"
        ></el-input
        >元
      </div>
      <div>
        初次培训报名费用：
        <el-input
          v-model="searchData.firstFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入初次培训报名费用"
        ></el-input
        >元
      </div>
    </div>
    <div v-if="setUpType == 2">
      <div>
        继续教育报名费用：
        <el-input
          v-model="searchData.monitorContinueFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入继续教育报名费用"
        ></el-input
        >元
      </div>
      <div>
        初次培训报名费用：
        <el-input
          v-model="searchData.monitorFirstFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入初次培训报名费用"
        ></el-input
        >元
      </div>
    </div>
    <div v-if="setUpType == 3">
      <div>
        继续教育报名费用：
        <el-input
          v-model="searchData.otherContinueFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入继续教育报名费用"
        ></el-input
        >元
      </div>
      <div>
        初次培训报名费用：
        <el-input
          v-model="searchData.otherFirstFeeNum"
          clearable
          style="width: 300px; margin: 20px 10px"
          size="small"
          placeholder="请输入初次培训报名费用"
        ></el-input
        >元
      </div>
    </div>

    <div class="common-title">报名科目设置</div>
    <div class="type-wrapper">
      <span
        class="type-title"
        @click="chooseType(1)"
        :style="setUpType == 1 ? 'color:blue;' : ''"
        >两类人员报名科目</span
      >
      <span
        class="type-title"
        @click="chooseType(2)"
        :style="setUpType == 2 ? 'color:blue;' : ''"
        >动态监控报名科目</span
      >
      <span
        class="type-title"
        @click="chooseType(3)"
        :style="setUpType == 3 ? 'color:blue;' : ''"
        >其他类别报名科目</span
      >
    </div>
	
	<div v-if="setUpType == 1">
		<div>
      报名科目：
      <el-input
        v-model="searchData.continueSubject"
        clearable
        style="width: 300px; margin: 20px 10px"
        size="small"
        placeholder="请输入报名科目名称"
      ></el-input>
    </div>
	</div>
	<div v-if="setUpType == 2">
		<div>
      报名科目：
      <el-input
        v-model="searchData.monitorContinueSubject"
        clearable
        style="width: 300px; margin: 20px 10px"
        size="small"
        placeholder="请输入报名科目名称"
      ></el-input>
    </div>
	</div>
	<div v-if="setUpType == 3">
		<div>
      报名科目：
      <el-input
        v-model="searchData.otherContinueSubject"
        clearable
        style="width: 300px; margin: 20px 10px"
        size="small"
        placeholder="请输入报名科目名称"
      ></el-input>
    </div>
	</div>
  

    <div class="common-title">报名材料设置</div>
    <!-- <div class="common-title">
			会员申请表模板
		</div> -->
    <div>
      <div style="margin: 20px 0" v-if="searchData.appTemplate != ''">
        <a :href="searchData.appTemplate">会员申请表.doc</a>
        <span
          style="margin-left: 20px; color: #f00; cursor: pointer"
          @click="delectFile()"
          >删除</span
        >
      </div>
      <el-upload
        :headers="$util.getUploadHeaders()"
        :before-upload="beforeAvatarUpload"
        :action="actionUrl"
        :on-success="handleAvatarSuccess"
        :show-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <!-- <div class="common-title">
			总经理任命书模板
		</div> -->
    <div>
      <div style="margin: 20px 0" v-if="searchData.appointmentTemplate != ''">
        <a :href="searchData.appointmentTemplate">总经理任命书模板.doc</a>
        <span
          style="margin-left: 20px; color: #f00; cursor: pointer"
          @click="delectFile11()"
          >删除</span
        >
      </div>
      <el-upload
        :headers="$util.getUploadHeaders()"
        :before-upload="beforeAvatarUpload"
        :action="actionUrl"
        :on-success="handleAvatarSuccess11"
        :show-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { moneySet, getMoneySet } from "../../api/main";
export default {
  data() {
    return {
      searchData: {
        continueFeeNum: "",
        firstFeeNum: "",
        appTemplate: "",
        appointmentTemplate: "",
        monitorContinueFeeNum: "",
        monitorFirstFeeNum: "",
        otherContinueFeeNum: "",
        otherFirstFeeNum: "",
		    continueSubject:"",//两类
		    monitorContinueSubject:"",// 动态
		    otherContinueSubject:""//其他
      },
      fileInfo: {},
      actionUrl: "",
      //				actionUrl:'http://19940309.xyz:20005/api/v1/uploadMaterial',
      setUpType: 1, // 1-两类，2-动态监控员，3-其他类别
    };
  },
  methods: {
    delectFile() {
      this.searchData.appTemplate = "";
      moneySet(this.searchData).then((res) => {
        if (res.code == 1) {
          getMoneySet().then((res) => {
            console.log(res);
            this.searchData = res.data;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    delectFile11() {
      this.searchData.appointmentTemplate = "";
      moneySet({
        appointmentTemplate: this.searchData.appointmentTemplate,
      }).then((res) => {
        if (res.code == 1) {
          getMoneySet().then((res) => {
            console.log(res);
            this.searchData = res.data;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    saveSetUp() {
      if (this.searchData.firstFeeNum == "") {
        this.$message.error("请输入初次培训金额");
        return;
      }
      if (this.searchData.firstFeeNum <= 0) {
        this.$message.error("初次培训金额需大于0");
        return;
      }
      if (this.searchData.continueFeeNum == "") {
        this.$message.error("请输入继续教育金额");
        return;
      }
      if (this.searchData.continueFeeNum <= 0) {
        this.$message.error("继续教育金额需大于0");
        return;
      }


      if (this.searchData.monitorFirstFeeNum == "") {
        this.$message.error("请输入动态监控初次培训金额");
        return;
      }
      if (this.searchData.monitorFirstFeeNum <= 0) {
        this.$message.error("动态监控初次培训金额需大于0");
        return;
      }
      if (this.searchData.monitorContinueFeeNum == "") {
        this.$message.error("请输入动态监控继续教育金额");
        return;
      }
      if (this.searchData.monitorContinueFeeNum <= 0) {
        this.$message.error("动态监控继续教育金额需大于0");
        return;
      }

      if (this.searchData.otherFirstFeeNum == "") {
        this.$message.error("请输入其他类别初次培训金额");
        return;
      }
      if (this.searchData.otherFirstFeeNum <= 0) {
        this.$message.error("其他类别初次培训金额需大于0");
        return;
      }
      if (this.searchData.otherContinueFeeNum == "") {
        this.$message.error("请输入其他类别继续教育金额");
        return;
      }
      if (this.searchData.otherContinueFeeNum <= 0) {
        this.$message.error("其他类别继续教育金额需大于0");
        return;
      }

      if (this.searchData.appTemplate == "") {
        this.$message.error("请选择会员模板");
        return;
      }

	  if (this.searchData.continueSubject == "") {
        this.$message.error("请输入两类人员科目名称");
        return;
      }
	  if (this.searchData.monitorContinueSubject == "") {
        this.$message.error("请输入动态监控科目名称");
        return;
      }
	  if (this.searchData.otherContinueSubject == "") {
        this.$message.error("请输入其他类别科目名称");
        return;
      }
	  console.log(this.searchData);
	  
      moneySet(this.searchData).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success("保存成功！");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 1) {
        this.$message.success("上传成功！");
        this.fileInfo = file;
        this.searchData.appTemplate = file.response.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleAvatarSuccess11(res, file) {
      if (res.code == 1) {
        this.$message.success("上传成功！");
        this.fileInfo = file;
        console.log(file.response);
        this.searchData.appointmentTemplate = file.response.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type;
      //				if(isJPG == 'image/jpeg' || isJPG == 'image/png') {
      return isJPG;
      //				} else {
      //					this.$message.error('上传头像图片只能是JPG或者PNG格式!');
      //				}
      return false;
    },
    httpRequest(data) {
      console.log(data);
    },
    // 选择费用类型
    chooseType(type) {
      this.setUpType = type;
    },
  },
  mounted() {
    this.actionUrl = `${this.$httpUrl}/api/v1/uploadMaterial`;
    // this.actionUrl = `http://192.168.12.205:8088/api/v1/uploadMaterial`
    getMoneySet().then((res) => {
      console.log(res);
      this.searchData = res.data;
    });
  },
};
</script>

<style scoped>
.type-wrapper {
  display: flex;
  align-items: center;
}
.type-title {
  margin-left: 20px;
  font-size: 18px !important;
  cursor: pointer;
  text-decoration: underline;
}
</style>
